import axios from "axios";

/**
 * FastAPI base URL — same host for auth, finance/transactions, and /api/cu/* (Kohl Direct).
 * CRA only inlines REACT_APP_* at build time.
 */
export function getApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
  if (process.env.NODE_ENV === "test") {
    return raw.startsWith("http") ? raw : "https://api.test";
  }
  if (!raw) {
    throw new Error(
      "Set REACT_APP_API_URL (e.g. https://kohlagapis.intelreach.com or http://localhost:8000).",
    );
  }
  if (process.env.NODE_ENV === "development") {
    if (
      raw.startsWith("http://localhost") ||
      raw.startsWith("http://127.0.0.1")
    ) {
      return raw;
    }
  }
  if (!raw.startsWith("https://")) {
    throw new Error(`REACT_APP_API_URL must use https:// in production (got: ${raw.slice(0, 40)}).`);
  }
  return raw;
}

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: Number(process.env.REACT_APP_API_TIMEOUT_MS || 60000),
});

api.interceptors.request.use((config) => {
  const path = String(config.url || "");
  const isLogin = path.includes("/auth/login");
  if (!isLogin) {
    const t = localStorage.getItem("access_token");
    if (t) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

/** Login without sending an existing Bearer token (username may be email or login name). */
export function loginRequest(usernameOrEmail, password) {
  return api.post("/auth/login", {
    username: String(usernameOrEmail).trim(),
    password,
  });
}

export function setAccessToken(token) {
  if (token) localStorage.setItem("access_token", token);
  else localStorage.removeItem("access_token");
}
